<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Add document
    </ng-container>

    <ng-container dialog-process-in-progress *ngIf="addDocumentForm && addDocumentForm.controls">
        <div [ngClass]="{'mb-3': addDocumentForm.controls[0].errors.length > 0}">
            <app-select
                [(ngModel)]="addDocumentForm.controls[0].value"
                [control]="addDocumentForm.controls[0]"
                (ngModelChange)="onDocumentTypeChange(true, $event)"
            ></app-select>
        </div>
        <div
            *ngIf="addDocumentForm.controls[0].value && !hiddenSubType"

            [ngClass]="{'mb-3': addDocumentForm.controls[1].errors.length > 0}"
        >
            <app-select
                [(ngModel)]="addDocumentForm.controls[1].value"
                [control]="addDocumentForm.controls[1]"
                (ngModelChange)="resetDocumentsTupleItem($event)"
            ></app-select>
        </div>
        <div
            *ngIf="addDocumentForm.controls[0].value === documentTypesEnum.ProofOfIdentity"

            [ngClass]="{'mb-3': addDocumentForm.controls[2].errors.length > 0}"
        >
            <app-panel-input
                [(ngModel)]="addDocumentForm.controls[2].value"
                [control]="addDocumentForm.controls[2]"
            ></app-panel-input>
        </div>
        <div
            *ngIf="addDocumentForm.controls[0].value === documentTypesEnum.ProofOfIdentity"

            [ngClass]="{'mb-3': addDocumentForm.controls[3].errors.length > 0}"
        >
            <app-lockable-datepicker
                [(ngModel)]="addDocumentForm.controls[3].value"
                [control]="addDocumentForm.controls[3]"
                [leftAligned]="true"
            ></app-lockable-datepicker>
        </div>
        <div [ngClass]="{'mb-3': addDocumentForm.controls[4].errors.length > 0}">
            <app-textarea
                [(ngModel)]="addDocumentForm.controls[4].value"
                [control]="addDocumentForm.controls[4]"
            ></app-textarea>
        </div>
        <div [ngClass]="{'mb-3': addDocumentForm.controls[5].errors.length > 0}">
            <app-checkbox
                [(ngModel)]="addDocumentForm.controls[5].value"
                [control]="addDocumentForm.controls[5]"
            >
                <ng-container text>Set as verified</ng-container>
            </app-checkbox>
        </div>
        <div [ngClass]="{'mb-3': addDocumentForm.controls[6].errors.length > 0}">
            <app-checkbox
                [(ngModel)]="addDocumentForm.controls[6].value"
                [control]="addDocumentForm.controls[6]"
            >
                <ng-container text>Set as visible for client</ng-container>
            </app-checkbox>
        </div>
        <div class="row">
            <div
                class="col-{{
                        ((addDocumentForm.controls[1].value === identityDocumentTypesEnum.IdentityCard) ||
                            (addDocumentForm.controls[1].value === identityDocumentTypesEnum.DrivingLicense)) ? 6 : 12
                    }}"
            >
                <app-upload-document
                    (documentUploaded)="addDocumentForm.onDocumentUpload($event, 0)"

                    [documentSubject]="addDocumentForm.documentsTuple[0]"
                    [documentErrorSubject]="addDocumentForm.documentsTupleErrors[0]"
                    [client]="data.client"
                ></app-upload-document>
            </div>
            <div
                *ngIf="
                        (addDocumentForm.controls[1].value === identityDocumentTypesEnum.IdentityCard) ||
                        (addDocumentForm.controls[1].value === identityDocumentTypesEnum.DrivingLicense)
                    "

                class="col-6"
            >
                <app-upload-document
                    (documentUploaded)="addDocumentForm.onDocumentUpload($event, 1)"

                    [documentSubject]="addDocumentForm.documentsTuple[1]"
                    [documentErrorSubject]="addDocumentForm.documentsTupleErrors[1]"
                    [client]="data.client"
                ></app-upload-document>
            </div>
        </div>
    </ng-container>
</app-dialog>
